module.exports = __webpack_public_path__ + "static/media/menu-hamburguer.f46c5546.svg";